import $ from 'jquery';
import setDobField from './utils/setDobField';
import calculateLifetimeRate from './utils/calculateLifetimeRate';
import serviceOptions from './utils/serviceOptions';

/*
 *  Add jQuery to the global scope so scripts supplied by GTM can
 *  access it
 */
window.jQuery = $;

$(document).ready(function() {

  //Get System Date
  const sysDate = new Date();

  //Set Element Variables
  let win = $(window),
        formElm = $('form.moaa-form'),
        pageOverlay = $('.page-overlay'),
        modalFrame = $('section.modal-frame'),
        radioFields = $('input[type="radio"]'),
        selectFields = $('form.moaa-form select'),
        submitButton = $('input[name="submit"]'),
        addressType = $('input[name="address_type"]'),
        membershipType = $('input[name="membership"]'),
        closeButton = $('#close-button-bar .close-button'),
        rankField = $('form.moaa-form select[name="rank"]'),
        emailField = $('form.moaa-form input[name="email"]'),
        serviceField = $('form.moaa-form select[name="service"]'),
        componentField = $('form.moaa-form select[name="component"]'),
        memberRateElm = $('.field-group-membership #membership-rate'),
        birthYearField = $('form.moaa-form input[name="unregistered-birth-year"]'),
        dobField;

  /*
   *  A list of data-name values for the premium form field elements
   */
  const premiumFields = [
    'country',
    'address1',
    'address2',
    'city',
    'state',
    'zipcode'
  ];


  //Set default member status and membership type
  let selectedMembership = 'BASIC',
      memberStatus = 'unregistered',
      errorCheck = [];

  dobField = setDobField(selectedMembership);

  /*******************************
  Reset Form
  Set modal position
  Set default select field values
  Set default radio fields
  *******************************/
  function init() {
    formElm[0].reset();

    selectFields.each(function() {
        let selectDisplay = $(this).parent().find(".select-display");
        selectDisplay.html($(this).children('option:selected').text());
    });

    radioFields.filter("[value='BASIC']").parent().addClass('selected-radio');
    radioFields.filter("[value='BASIC']").attr('checked', 'checked');

    formDetail('close');
  }

  //Updates select field values in custom select-display element
  $(selectFields).on('change', function() {
    let selectedOption = $(this).children("option:selected").text(),
        selectDisplay = $(this).parent().find('.select-display');

    selectDisplay.html(selectedOption);
  });

  /*
   *  Add the blue outline around the select fields
   *  for tabbed viewing
   */
  $(selectFields).on('focus', function (event) {
    $(this).parent().addClass('focus-outline');
  });

  $(selectFields).blur('focus', function (event) {
    $(this).parent().removeClass('focus-outline');
  });


  //Displays the respective pushed state and updates selectedMembership value
  radioFields.filter("[name='membership']").on('change', function() {
    radioFields.filter("[name='membership']").parent().removeClass('selected-radio');
    $(this).parent().addClass('selected-radio');
    selectedMembership = $(this).attr('value');

    dobField = setDobField(selectedMembership);

    if(selectedMembership == 'PREMIUM' || selectedMembership == 'LIFE') {
      formDetail('open');
    } else {
      formDetail('close');
    }

  });

  $('body').on('blur', '[name="unregistered-dob"], [name="unregistered-birth-year"]', (e) => {

    let defaultMessage = '<small>(Enter Birthdate For Dues)</small>';

    let priceMessage,
      membershipCost = calculateLifetimeRate(e.currentTarget.value);

    if (membershipCost === null) {
      priceMessage = defaultMessage;
    } else {
      priceMessage = membershipCost ? `$${membershipCost}.00` : 'FREE';
    }

    memberRateElm.html(priceMessage);
  });

  //Sets the rank and component options based on the selected service branch
  serviceField.on('change', function() {

    let selectedService = $(this).val();

    let {ranks, components} = serviceOptions[selectedService];

    rankField.html('').append('<option value="" selected>Rank*</option>');
    componentField.html('').append('<option value="" selected>Component*</option>');

    ranks.map((rank) => {
      rankField.append(`<option value="${rank}">${rank}</option>`);
    });

    components.map((comp) => {
      componentField.append(`<option value="${comp}">${comp}</option>`);
    });

  });

  //Handles showing and hiding additional Premium and Life fields
  function formDetail(dropDownAction) {
    if (dropDownAction === 'open') {
      $('.detail-form').slideDown();

    } else {
      $('.detail-form').slideUp();
    }

    premiumFields.map(dataName => {
      document.querySelector(`[data-name="${dataName}"]`).disabled = (dropDownAction === 'close');
    });

  }

  /*
   *  Hide and disable the state field if the country isn't
   *  the US
   */
  $('body').on('change', 'select[name="country"]', function(e) {
    let stateField = document.querySelector('[name="state"]');
    let disabled = e.currentTarget.value != 'US';
    stateField.disabled = disabled;
    $(stateField).parents('.field-row').css('display', disabled ? 'none' : '');
  });

  function gtmMembershipSubmission (gtmMemberType) {
    window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
      'event': 'joinMoaaSubmission',
      'radioSelection': gtmMemberType
    });
  }

  //Handles form validation
  formElm.on('submit', function(event) {

    //Accessing form elements
    let submit = $('input[name="submit"]'),
        firstName = $('input[name="fname"]'),
        lastName = $('input[name="lname"]'),
        dob = $('form.moaa-form input[name="unregistered-dob"]'),
        unregisteredBirthYear = $('input[name="unregistered-birth-year"]'),
        registeredBirthYear = $('input[name="registered-birth-year"]'),
        service = $('select[name="service"]'),
        rank = $('select[name="rank"]'),
        component = $('select[name="component"]'),
        status = $('select[name="status"]'),
        country = $('select[name="country"]'),
        addressOne = $('input[name="address_one"]'),
        addressTwo = $('input[name="address_two"]'),
        city = $('input[name="city"]'),
        company = $('input[name="company"]'),
        state = $('select[name="state"]'),
        zipCode = $('input[name="zipcode"]'),
        registeredZipCode = $('input[name="registered-zipcode"]'),
        email = $('input[name="email"]'),
        username = $('input[ name="username"]'),
        password = $('input[ name="password"]'),
        passwordVerify = $('input[ name="verify_password"]');

    if (password.val() !== passwordVerify.val()) {
      passwordVerify.get(0).setCustomValidity('Passwords do not match');
    } else {
      passwordVerify.get(0).setCustomValidity('');
    }

    const formElements = Array.from(document.forms['moaa-form'].elements);

    let validityStatuses = [],
      isFormValid;

    formElements.map(el => {
      let isValid = el.checkValidity();
      el.parentNode.classList[isValid ? 'remove' : 'add']('error');
      validityStatuses.push(isValid);
    });

    /*
     *  Provide specific feedback with the HTML5 form constraint AP
     *  as a bonus. This will not work in IE11.
     */
    try {
      isFormValid = document.forms['moaa-form'].reportValidity();
    } catch(e) {
      isFormValid = validityStatuses.all(x => x);
    }

    if (!isFormValid) {
      event.preventDefault();
    }

  });

  //Handles closing the form modal
  closeButton.on('click', function() {
    pageOverlay.addClass('close-modal');
  });

  init();
});
